module.exports = __webpack_public_path__ + "img/burundi.e05683e3.svg";